import { trace } from '../../../configuration/setup/trace';

export const SELECT_GEOFENCES_EVENT = 'EVENT_SELECT_GEOFENCES';

export const selectGeofencesHandler = (data: string[]) => {
    trace.debug('Selected Geofences data:', data);
};
